module.exports = __webpack_public_path__ + "img/reupdate.b04cb9ea.png";